<script setup lang="ts">
import { defineProps, defineEmits, watch } from 'vue';
import { AnOutlinedClose } from "@kalimahapps/vue-icons";

const props = defineProps({ visible: Boolean, announcement: Object });
const emit = defineEmits(['close']);

const close = () => emit('close');
watch(() => props.visible, (val) => { document.body.style.overflow = val ? 'hidden' : ''; });

const formatDate = (dateString: string) => {
  if (!dateString) return '';
  const d = new Date(dateString); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
};
</script>

<template>
  <transition name="modal-fade">
    <div class="modal-overlay" v-if="props.visible" @click.self="close">
      <div class="modal-box">
        <button class="close-btn" @click="close"><AnOutlinedClose /></button>

        <div class="modal-head-slim">
          <img :src="announcement?.cover_image" class="slim-cover" />
          <div class="slim-info">
            <h2 class="slim-title">{{ announcement?.title }}</h2>
            <div class="slim-meta">
              <span class="slim-date">{{ formatDate(announcement?.published_at) }}</span>
              <!-- 展示作者 -->
              <span class="slim-author" v-if="announcement?.author"> | By: {{ announcement.author }}</span>
            </div>
          </div>
        </div>

        <!-- 直接渲染后端传来的 WangEditor 生成的 HTML -->
        <div class="modal-body wangeditor-content" v-html="announcement?.content"></div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.modal-overlay { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); backdrop-filter: blur(5px); z-index: 9999; display: flex; justify-content: center; align-items: center; }
.modal-box { width: 90%; max-width: 850px; height: 85vh; background: #fff; border-radius: 12px; display: flex; flex-direction: column; position: relative; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.4); }

.close-btn { position: absolute; top: 20px; right: 20px; background: rgba(0,0,0,0.05); border: none; width: 35px; height: 35px; border-radius: 50%; font-size: 20px; cursor: pointer; z-index: 10; transition: 0.3s; display: flex; align-items: center; justify-content: center; }
.close-btn:hover { background: #f77373; color: white; transform: rotate(90deg); }

.modal-head-slim { display: flex; align-items: center; padding: 25px 40px; border-bottom: 1px solid #eee; background: #fafafa; flex-shrink: 0; }
.slim-cover { width: 80px; height: 50px; border-radius: 6px; object-fit: cover; margin-right: 20px; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }
.slim-info { flex: 1; }
.slim-title { margin: 0 0 5px; font-family: 资源圆体, sans-serif; font-size: 1.6rem; color: #333; }
.slim-meta { font-size: 0.85rem; color: #888; font-family: sans-serif; }
.slim-author { color: #57E1D9; font-weight: bold; }

.modal-body { padding: 40px; overflow-y: auto; color: #333; font-family: 资源圆体, sans-serif; }

.modal-fade-enter-active, .modal-fade-leave-active { transition: all 0.3s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity: 0; transform: translateY(30px) scale(0.98); }

/* 为 WangEditor 输出的内容加点基础限制 */
:deep(.wangeditor-content img) { max-width: 100%; border-radius: 8px; margin: 10px 0; }
:deep(.wangeditor-content p) { line-height: 1.8; margin-bottom: 15px; font-size: 1.05rem; }
:deep(.wangeditor-content blockquote) { border-left: 4px solid #57E1D9; padding-left: 10px; color: #666; background: #f9f9f9; padding: 10px; border-radius: 4px; }
:deep(.wangeditor-content ul), :deep(.wangeditor-content ol) { padding-left: 20px; margin-bottom: 15px; }
</style>
